<div class="resend-fax">
  <h2 class="resend-fax__title">Message</h2>

  <div class="resend-fax__body">
    <span>Status:</span>

    <p class="paper resend-fax__error-message">
      <img src="/assets/icons/error.svg" alt="" class="resend-fax__error-icon" />
      {{ errorMessage }}
    </p>

    <button class="btn_primary btn_lg" (click)="retry.emit()">Retry</button>
  </div>
</div>
